import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from './utils'

type AlertTone = 'error' | 'warning' | 'success' | 'info'

const toneClass: Record<AlertTone, string> = {
  error:
    'border-red-200 bg-red-50 text-red-900 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-200',
  warning:
    'border-amber-200 bg-amber-50 text-amber-950 dark:border-amber-900/40 dark:bg-amber-950/35 dark:text-amber-100',
  success:
    'border-emerald-200 bg-emerald-50 text-emerald-900 dark:border-emerald-900/40 dark:bg-emerald-950/40 dark:text-emerald-200',
  info:
    'border-violet-200/80 bg-violet-50/90 text-violet-900 dark:border-violet-500/20 dark:bg-violet-950/50 dark:text-violet-200',
}

const defaultRole: Record<AlertTone, HTMLAttributes<HTMLDivElement>['role']> = {
  error: 'alert',
  warning: 'alert',
  success: 'status',
  info: 'status',
}

export type AlertProps = HTMLAttributes<HTMLDivElement> & {
  tone?: AlertTone
  children: ReactNode
}

export function Alert({
  tone = 'info',
  className,
  role,
  children,
  ...props
}: AlertProps) {
  return (
    <div
      className={cx(
        'rounded-2xl border px-4 py-3 text-sm',
        toneClass[tone],
        className,
      )}
      role={role ?? defaultRole[tone]}
      {...props}
    >
      {children}
    </div>
  )
}
